import React, { useState, useEffect } from "react";
import axios from "axios";
import Brands1 from "../components/brands/Brands1";
import { FaTimes, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import BreadcrumbsHeader from "../components/breadcrumbs/BreadcrumbsHeader";

const LifeAtIsols = () => {
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [filteredImages, setFilteredImages] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Fetch categories & images on load
  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const [catRes, imgRes] = await Promise.all([
          axios.get("https://www.isolsgroup.com/new/api/ApiGalleryCategory", {
            headers: { "X-API-KEY": "ISOLS" },
          }),
          axios.get("https://www.isolsgroup.com/new/api/ApiGalleryImage", {
            headers: { "X-API-KEY": "ISOLS" },
          }),
        ]);

        const catData = catRes.data?.data || [];
        const imgData = imgRes.data?.data || [];

        setCategories(catData);
        setImages(imgData);
        setFilteredImages(imgData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
        setLoading(false);
      }
    };

    fetchGalleryData();
  }, []);

  // ✅ Handle tab filter
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setSelectedIndex(null);

    if (tab === "all") {
      setFilteredImages(images);
    } else {
      const filtered = images.filter((img) => img.gallery_id === tab);
      setFilteredImages(filtered);
    }
  };

  // ✅ Popup navigation
  const handleNext = () =>
    setSelectedIndex((selectedIndex + 1) % filteredImages.length);

  const handlePrev = () =>
    setSelectedIndex(
      (selectedIndex - 1 + filteredImages.length) % filteredImages.length
    );

  return (
    <div className="page-container">
      {/* Breadcrumbs */}
            <BreadcrumbsHeader 
        title="Life @ISOLS" 
        backgroundImage="/images/header/life@isols.jpg" 
      />

      
      {/* About Section */}
      <section className="section-about">
        <div className="container text-center">
          <p className="first-heading font-secondary wow fadeInDown">
            Glimpse of ISOLS
          </p>
          <h2 className="heading-line line-right customColor customPseudoElBg wow fadeIn">
            <strong>Lively Vibrant Culture</strong>
          </h2>
          <p className="second-heading font-additional">
            We have together grown &amp; nurtured as a family. Determining a healthy
            and lively quality of life of each ISOLIAN is our religion. We work together,
            play together, share together, celebrate together, innovate together and disrupt together.
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="section-services2">
        <div className="container">
          {loading ? (
            <p className="text-center">Loading gallery...</p>
          ) : (
            <>
              {/* Tabs */}
              <div className="b-items-works text-uppercase text-center clearfix">
                <ul className="list-inline b-items-sort">
                  <li
                    className={activeTab === "all" ? "active-filt" : ""}
                    onClick={() => handleTabClick("all")}
                  >
                    All
                  </li>
                  {categories.map((cat) => (
                    <li
                      key={cat.id}
                      className={activeTab === cat.id ? "active-filt" : ""}
                      onClick={() => handleTabClick(cat.id)}
                    >
                      {cat.gallery_thumb_name}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Image Grid */}
              <div
                className="b-works-holder text-center"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                {filteredImages.map((img, index) => (
                  <div
                    key={index}
                    className="col-md-3 col-sm-4 col-xs-12 works-item"
                    style={{
                      cursor: "pointer",
                      borderRadius: "10px",
                      overflow: "hidden",
                      margin: "10px",
                    }}
                    onClick={() => setSelectedIndex(index)}
                  >
                    <img
                      src={`https://www.isolsgroup.com/uploaded-images/gallery/${img.image}`}
                      alt={img.title || "Gallery"}
                      className="img-responsive center-block"
                      style={{
                        width: "100%",
                        borderRadius: "10px",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Popup / Lightbox */}
          {selectedIndex !== null && filteredImages.length > 0 && (
            <div
              onClick={() => setSelectedIndex(null)}
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.9)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{ position: "relative", textAlign: "center" }}
              >
                {/* Close */}
                <button
                  onClick={() => setSelectedIndex(null)}
                  style={{
                    position: "absolute",
                    top: "-40px",
                    right: "0",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#fff",
                    fontSize: "28px",
                  }}
                >
                  <FaTimes />
                </button>

                {/* Prev */}
                <button
                  onClick={handlePrev}
                  style={{
                    position: "absolute",
                    left: "-60px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#fff",
                    fontSize: "32px",
                  }}
                >
                  <FaArrowLeft />
                </button>

                {/* Image */}
                <img
                  src={`https://www.isolsgroup.com/uploaded-images/gallery/${filteredImages[selectedIndex].image}`}
                  alt="popup"
                  style={{
                    maxWidth: "90vw",
                    maxHeight: "80vh",
                    borderRadius: "10px",
                    boxShadow: "0 4px 20px rgba(255,255,255,0.3)",
                  }}
                />

                {/* Next */}
                <button
                  onClick={handleNext}
                  style={{
                    position: "absolute",
                    right: "-60px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#fff",
                    fontSize: "32px",
                  }}
                >
                  <FaArrowRight />
                </button>
              </div>
            </div>
          )}
        </div>
      </section>

      <Brands1 />
    </div>
  );
};

export default LifeAtIsols;
